module.exports = __webpack_public_path__ + "assets/delete.f582c82b.svg";